import { Api } from '../services/api.ts';
import type { BackupData } from '../types/index.ts';

export function initBackup(onDataRestored: () => void) {
  const btnExport = document.getElementById('btn-export-json') as HTMLButtonElement | null;
  const btnImportTrigger = document.getElementById('btn-import-trigger') as HTMLButtonElement | null;
  const fileInput = document.getElementById('file-import-json') as HTMLInputElement | null;

  btnExport?.addEventListener('click', async () => {
    const span = btnExport.querySelector('span');
    const originalText = span ? span.innerText : btnExport.innerText;
    try {
      if (span) span.innerText = 'Generando respaldo...';
      else btnExport.innerText = 'Generando respaldo...';
      const backup = await Api.exportBackup();
      const jsonStr = JSON.stringify(backup, null, 2);

      const blob = new Blob([jsonStr], { type: 'application/json;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Tesis_Damke_SQLite_Backup_${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error al generar respaldo desde SQLite');
    } finally {
      if (span) span.innerText = originalText;
      else btnExport.innerText = originalText;
    }
  });

  btnImportTrigger?.addEventListener('click', () => {
    fileInput?.click();
  });

  fileInput?.addEventListener('change', async (e) => {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    if (!confirm('Esta acción sincronizará y restaurará la base de datos SQLite con los datos del archivo seleccionado. ¿Deseas continuar?')) {
      target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const parsed = JSON.parse(evt.target?.result as string) as BackupData;
        const res = await Api.importBackup(parsed);
        alert(res.message || 'Base de datos SQLite restaurada con éxito.');
        onDataRestored();
      } catch (err: any) {
        alert('Error restaurando base de datos: ' + (err.message || 'JSON inválido'));
      } finally {
        target.value = '';
      }
    };
    reader.readAsText(file);
  });
}
